import successTrx from 'assets/images/success-trx.png'
import { getMetaContent } from 'helpers'
import { useSelector } from 'react-redux'
import { Card, Container } from 'reactstrap'

const ConfirmPageEnd = () => {
  const { msg } = useSelector((s) => s.reqTrxSell)

  return (
    <Container
      className="d-flex align-items-center justify-content-center w-100 h-100"
      style={{ minHeight: '100vh' }}
    >
      <Card
        style={{ maxWidth: 480 }}
        className="px-2 mx-auto d-flex justify-content-center align-items-center w-100"
      >
        <img
          src={getMetaContent('og:image')}
          alt={`${getMetaContent('og:title')} logo`}
          className="text-center"
          style={{
            marginTop: 32,
            marginBottom: 24,
            width: '100%',
            maxWidth: '150px',
            height: 'auto',
          }}
        />

        <img
          style={{ width: '280px', height: '182px' }}
          alt="success transaction"
          src={successTrx}
        />
        <h6 className="fw-bold mt-3">Konfirmasi diterima!</h6>
        <span className="mb-4 text-center" data-testid="order-success-message">
          {msg}
        </span>
      </Card>
    </Container>
  )
}

export default ConfirmPageEnd
